import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ExpertsItem from './ExpertsItem/ExpertsItem';
import styles from './Experts.module.scss';

const ExpertsPage = () => {
  const [experts, setExperts] = useState();
  const [expertsText, setExpertsText] = useState();
  const [accreditationText, setAccreditationText] = useState();
  const [accreditationDocs, setAccreditationDocs] = useState();

  const expertsRedux = useSelector((state) => state.experts.experts);
  const expertsTextRedux = useSelector((state) => state.experts.text);

  const accreditationInfoRedux = useSelector((state) => state.accreditationDocuments.text);
  const accreditationDocsRedux = useSelector((state) => state.accreditationDocuments.accreditationDocuments);

  useEffect(() => {
    if (!expertsRedux) return;
    setExperts(expertsRedux);
  }, [expertsRedux]);

  useEffect(() => {
    if (!expertsTextRedux) return;
    setExpertsText(expertsTextRedux);
  }, [expertsTextRedux]);

  useEffect(() => {
    if (!accreditationInfoRedux) return;
    setAccreditationText(accreditationInfoRedux);
  }, [accreditationInfoRedux]);

  useEffect(() => {
    if (!accreditationDocsRedux) return;
    setAccreditationDocs(accreditationDocsRedux);
  }, [accreditationDocsRedux]);

  return (
    <div className={styles.workersBox}>
      {expertsText && <p className={styles.mainDescription}>{expertsText}</p>}
      <div className={styles.workersWrapper}>
        {experts &&
          experts.map((item, index) => (
            <ExpertsItem
              key={index}
              photo={item.cropped_photo}
              fio={item.fio}
              position={item.description}
              email={item.email}
              phone={item.phone}
            />
          ))}
      </div>

      {accreditationDocs?.length > 0 && (
        <div className={styles.accreditation}>
          <h2 className={styles.accreditationTitle}>Аккредитация экспертного совета</h2>
          <div dangerouslySetInnerHTML={{ __html: accreditationText }} className={styles.accreditationDesc} />
          <ul className={styles.accreditationDocs}>
            {accreditationDocs.map((item) => (
              <li key={item.id} className={styles.accrItem}>
                <a href={item.file} target="_blank" rel="noreferrer">
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ExpertsPage;
